import React from 'react'
import { Link } from 'react-router'
import PropTypes from "prop-types"
import { min, values, get, sortBy } from 'lodash'
import { Glyphicon, Panel, OverlayTrigger, Tooltip } from 'react-bootstrap'

import Button from '../components/Button.jsx'
import { getText } from '../lib/text.js'
import checkIfProductIsReady from './ProductsTools.jsx'
import { SimpleTagsList } from '../tags/TagsList'

import "./ProductsPage.less"

const TypeTrans = {
  restaurant: "Restaurantes",
  ticket: "Entradas",
  onedaytrip: "OneDay Trips",
  shopping: "Tiendas",
  other: "Productos"
}

class ProductsList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { rank: false }
  }

  render() {
    const { bsStyle, onChange, city, type, organizedProducts, tags, onAdd } = this.props

    const products = values(get(organizedProducts, [city, type], {}))
    const productsList = sortBy(products, product => (-product.rank))
    const activeProducts = products.filter(product => product.isVisible && checkIfProductIsReady(product))
    const activeCount = activeProducts.length

    return (
      <Panel className="products-list" bsStyle={bsStyle}>
        <Panel.Heading>
          {`${TypeTrans[type]} (${activeCount} activos)`}
          <Button
            glyph="list"
            active={this.state.rank}
            onClick={() => this.setState({ rank: !this.state.rank })}
            tooltipText="Ordenar"
            bsSize="xsmall"
          />
        </Panel.Heading>
        <Panel.Body>
          <ul>
            {
              productsList
                .map(product => (
                  <li key={product._id}>
                    <input
                      type="checkbox"
                      disabled={!checkIfProductIsReady(product)}
                      checked={product.isVisible && checkIfProductIsReady(product)}
                      onChange={evt => onChange(product._id, { isVisible: evt.target.checked })}
                    />

                    {
                      this.state.rank && (
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip style={{ fontSize: 15 }}>
                              Se recomienda usar de 0 a 100 puntos
                            </Tooltip>
                          }
                        >
                          <input
                            type="number"
                            value={product.rank || 0}
                            onChange={evt => {
                              const rank = min([ 999, parseInt(evt.target.value) || 0 ])
                              onChange(product._id, { rank })
                            }}
                          />
                        </OverlayTrigger>
                      )
                    }

                    <Link to={`/private/product/${encodeURIComponent(product._id)}`}>
                      {product.name || "Sin nombre"}
                      {product.chName && `(${product.chName})`}
                    </Link>

                    <SimpleTagsList
                      allTags={tags || {}}
                      selectedTags={product.tags || {}}
                      tagType="products"
                    />
                    {
                      !checkIfProductIsReady(product) && (
                        <div style={{ display: "inline" }}>
                          <Glyphicon glyph="warning-sign" style={{ color: "orange" }}/>
                          {' Faltan datos'}
                        </div>
                      )
                    }
                  </li>
                ))
            }
          </ul>

          <Button
            onClick={() => onAdd(type, city)}
            style={{ width: "30%", marginRight: 5, marginTop: 5, marginBottom: 5 }}
            glyph="plus"
          >
            {getText(`Añadir ${TypeTrans[type].toLowerCase().slice(0, -1)}`)}
          </Button>
        </Panel.Body>
      </Panel>
    )
  }
}

ProductsList.propTypes = {
  bsStyle: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  city: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  organizedProducts: PropTypes.object.isRequired,
  tags: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired
}

export default ProductsList
